import promiseMiddlware from 'redux-promise-middleware';
import rootReducer from '../rootReducer';
import thunkMiddleware from 'redux-thunk';
import {applyMiddleware, createStore} from 'redux';

export default function (initialState) {
  const middleware = [
    thunkMiddleware,
    promiseMiddlware()
  ];

  return createStore(
    rootReducer,
    initialState,
    applyMiddleware(...middleware)
  );
}



// WEBPACK FOOTER //
// ./app/store/configureStore.prod.js